import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  row-gap: 16px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  row-gap: 16px;
`;
